import { SVGInterface } from "../../interface";

const Bicycle = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15.2083 6.20732C16.2167 6.20732 17.0417 5.37317 17.0417 4.35366C17.0417 3.33415 16.2167 2.5 15.2083 2.5C14.2 2.5 13.375 3.33415 13.375 4.35366C13.375 5.37317 14.2 6.20732 15.2083 6.20732ZM5.58333 12.2317C3.01667 12.2317 1 14.2707 1 16.8659C1 19.461 3.01667 21.5 5.58333 21.5C8.15 21.5 10.1667 19.461 10.1667 16.8659C10.1667 14.2707 8.15 12.2317 5.58333 12.2317ZM5.58333 20.1098C3.84167 20.1098 2.375 18.6268 2.375 16.8659C2.375 15.1049 3.84167 13.622 5.58333 13.622C7.325 13.622 8.79167 15.1049 8.79167 16.8659C8.79167 18.6268 7.325 20.1098 5.58333 20.1098ZM10.9 10.8415L13.1 8.61707L13.8333 9.35854C15.025 10.5634 16.5833 11.3049 18.5083 11.3049V9.45122C17.1333 9.45122 16.0333 8.89512 15.2083 8.06098L13.4667 6.3C13.0083 5.92927 12.55 5.7439 12 5.7439C11.45 5.7439 10.9917 5.92927 10.7167 6.3L8.15 8.89512C7.78333 9.26585 7.6 9.72927 7.6 10.1927C7.6 10.7488 7.78333 11.2122 8.15 11.4902L11.0833 14.0854V18.7195H12.9167V12.9732L10.9 10.8415ZM18.4167 12.2317C15.85 12.2317 13.8333 14.2707 13.8333 16.8659C13.8333 19.461 15.85 21.5 18.4167 21.5C20.9833 21.5 23 19.461 23 16.8659C23 14.2707 20.9833 12.2317 18.4167 12.2317ZM18.4167 20.1098C16.675 20.1098 15.2083 18.6268 15.2083 16.8659C15.2083 15.1049 16.675 13.622 18.4167 13.622C20.1583 13.622 21.625 15.1049 21.625 16.8659C21.625 18.6268 20.1583 20.1098 18.4167 20.1098Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Bicycle;
